const isIOSDevice = () => {
    if (typeof navigator === 'undefined' || typeof document === 'undefined') {
        return false
    }
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    )
}

export default isIOSDevice
